<template>
    <div>
            <nav class="nav-extended indigo darken-3">
                <div class="nav-content">
                            <router-link :to="{name: 'TodoApp'}">
                                <span class="nav-title" style="padding:0px;margin:10px 20px">To-Do List</span>
                            </router-link>
                        
                    <a href="" class="btn-floating btn-large halfway-fab pink" >
                      <router-link :to="{name: 'AddTask'}" style="text-decoration:none">
                          <i class="material-icons">add</i>
                      </router-link>
                    </a>
              </div>
          </nav>

      
  </div>
</template>

<script>

export default {
  name: 'Todo-Navbar',
  data() {
      return{

      }
  }
}
</script>

<style scoped>

.home{
    padding: 15px 10px;
    font-size:250%;
}
</style>